// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__xx8bN","modal":"Cart_modal__vrBi3"};